import authService, { TOKEN_TYPES } from "./authService";
import { toBackendTrialId } from "@/utils/trialIdMap";

/** Read-only registry of every definition governing a trial. */

export type DefinitionFamily = {
  label: string;
  owner: string;
  /** Scope-relative route to where this family is authored. */
  route: string;
};

export type TrialDefinition = {
  family: string;
  id: number | null;
  name: string;
  subject: string;
  summary: string;
  version: number | null;
  scope: "trial" | "tenant" | "default";
  effective_from: string | null;
  author: string | null;
  reason_for_change: string;
};

export type TrialDefinitions = {
  families: Record<string, DefinitionFamily>;
  definitions: TrialDefinition[];
};

const definitionsApi = {
  list: async (trialId: string): Promise<TrialDefinitions> => {
    const token = authService.getToken(TOKEN_TYPES.ACCESS) ?? "";
    const response = await fetch(
      `${import.meta.env.VITE_API_URL}/data/trial/${toBackendTrialId(trialId)}/definitions/`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );
    if (!response.ok) {
      throw new Error(`Could not load definitions (${response.status})`);
    }
    return (await response.json()) as TrialDefinitions;
  },
};

export default definitionsApi;
